import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { TopBanner } from './components/TopBanner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { DeviceMarketplace } from './components/DeviceMarketplace';
import { FamilyPlans } from './components/FamilyPlans';
import { ConsoleMockup } from './components/ConsoleMockup';
import { Pricing } from './components/Pricing';
import { CpuIcon } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-white text-[#333333] selection:bg-[#13E200] selection:text-black" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Navbar data-id="element-2" />

      <main className="pt-16" data-id="element-3">
        <Hero data-id="element-4" />
        <DeviceMarketplace data-id="element-5" />
        <FamilyPlans data-id="element-6" />
        <Pricing data-id="element-7" />
        <ConsoleMockup data-id="element-8" />
      </main>

      <footer className="bg-black text-white py-16" data-id="element-9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-12" data-id="element-11">
            <div className="flex items-center gap-2" data-id="element-12">
              <div className="w-8 h-8 bg-[#13E200] rounded-full flex items-center justify-center" data-id="element-13">
                <CpuIcon className="w-5 h-5 text-black" data-id="element-14" />
              </div>
              <span className="text-2xl font-black tracking-tighter text-white uppercase" data-id="element-15">
                Effy<span className="text-[#13E200]" data-id="element-16">Mobile</span>
              </span>
            </div>

            <div className="flex gap-8 text-sm font-medium text-gray-500" data-id="element-17">
              <a href="#" className="hover:text-white transition-colors" data-id="element-18">
                Terms
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-19">
                Privacy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-20">
                Security
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-21">
                Coverage
              </a>
            </div>

            <p className="text-xs text-gray-600 font-mono" data-id="element-22">
              © 2026 EFFY MOBILE INFRASTRUCTURE. ALL RIGHTS RESERVED.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}